import React from "react";

import { InputAdornment, TextField, IconButton } from "@mui/material";
import { Search } from "@mui/icons-material";

const SearchField = ({ query,setQuery ,placeholder,w}) => {
  return (
    <TextField
      onChange={(e) => setQuery(e.target.value)}
      sx={{ m: 1, minWidth: 120, maxWidth: w??160 }}
      size="small"
      fullWidth
      value={query}
      
      variant="outlined"
      placeholder={placeholder??"Search"}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton>
              <Search />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchField;
